import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  loaderContainer: { textAlign: 'center' },
  loader: { marginTop: '20vh' },
  colorPrimary: {
    color: '#5721E5',
  },
  loaderTypography: {
    color: '#5721E5',
  },
}));

function AppLoadingIndicator() {
  const { classes } = useStyles();

  return (
    <div className={classes.loaderContainer}>
      <CircularProgress
        size={40}
        thickness={4}
        value={100}
        classes={{ colorPrimary: classes.colorPrimary }}
        className={classes.loader}
      />
      <Typography className={classes.loaderTypography} gutterBottom>
        Carregando MinhaAgenda...
      </Typography>
    </div>
  );
}

export default AppLoadingIndicator;
